export const getContactTagList = state => {
    return state.list
}

export const getContactTagDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/contactTag/getters.js